/* UserGroupList.js — گروه‌های کاربری (واحد سازمانی)
   این با «گروه دسترسی» فرق دارد: گروه کاربری تعیین می‌کند کاربر کدام سطرهای
   داده را می‌بیند (UserGroupCode روی tblCredit، tblRefund و مانند آن).
*/
import React, { useState, useEffect, useCallback } from 'react';
import { TabBar } from '../TabManager';

const toFa = n => n===null||n===undefined?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const API  = (path,opts={}) => fetch(`/api/system${path}`,{
  headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('access')}`},...opts,
}).then(async r=>{
  // پاسخ غیر JSON (خطای سرور یا شبکه) هم باید به کاربر نشان داده شود، نه اینکه دکمه بی‌صدا بماند
  try { return await r.json(); }
  catch { return {ok:false, error:`پاسخ نامعتبر از سرور (کد ${r.status})`}; }
}).catch(()=>({ok:false, error:'ارتباط با سرور برقرار نشد'}));

export default function UserGroupList({ user, onBack }) {
  const [rows,setRows]         = useState([]);
  const [loading,setLoading]   = useState(false);
  const [selected,setSelected] = useState(null);
  const [modal,setModal]       = useState(null);
  const [title,setTitle]       = useState('');
  const [remark,setRemark]     = useState('');
  const [error,setError]       = useState('');
  const [toast,setToast]       = useState('');
  const [search,setSearch]     = useState('');

  const showToast = m => { setToast(m); setTimeout(()=>setToast(''),2800); };

  const fetchData = useCallback(async()=>{
    setLoading(true);
    const d = await API('/user-groups/');
    if(d.ok){ setRows(d.rows); setSelected(null); } else alert(d.error||'خطا');
    setLoading(false);
  },[]);

  useEffect(()=>{ fetchData(); },[fetchData]);

  // دکمه‌های باز برای کاربر جاری؛ تا جواب نیامده همه بسته‌اند
  const [sp,setSp] = useState({});
  useEffect(()=>{ (async()=>{
    try{ const d = await API('/menu-permissions/'); if(d.ok) setSp(d); }
    catch(e){ console.error(e); }
  })(); },[]);

  const openNew  = ()=>{ setTitle(''); setRemark(''); setError(''); setModal('new'); };
  const openEdit = ()=>{ if(!selected) return; setTitle(selected.title);
    setRemark(selected.remark||''); setError(''); setModal('edit'); };

  const save = async()=>{
    if(!title.trim()){ setError('عنوان گروه کاربری وارد نشده است'); return; }
    const url = modal==='new' ? '/user-groups/create/' : `/user-groups/${selected.code}/update/`;
    const d = await API(url,{method:'POST',body:JSON.stringify({title,remark})});
    if(d.ok){ setModal(null); fetchData(); showToast(modal==='new'?'✅ ثبت شد':'✅ ویرایش شد'); }
    else setError(d.error||'خطا');
  };

  const del = async()=>{
    const d = await API(`/user-groups/${selected.code}/delete/`,{method:'POST'});
    if(d.ok){ setModal(null); fetchData(); showToast('✅ حذف شد'); }
    else setError(d.error||'خطا');
  };

  const filtered = rows.filter(r=>!search.trim()
    || r.title.includes(search.trim()) || (r.remark||'').includes(search.trim()));

  return (
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}><img src={require('../../assets/images/arjan.png')} alt="" style={{width:'34px',height:'34px',borderRadius:'7px'}}/></div>
          <div><div style={s.hTitle}>گروه‌های کاربری</div><div style={s.hSub}>واحد سازمانی — بخش سیستم</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>
      <TabBar/>

      <main style={s.main}>
        <div style={s.toolbar}>
          <div style={s.toolBtns}>
            {sp.groups_new && <button onClick={openNew} style={s.btnNew}>＋ جدید</button>}
            {sp.groups_edit && <button onClick={openEdit} disabled={!selected} style={{...s.btnEdit,opacity:selected?1:.4}}>✎ ویرایش</button>}
            {sp.groups_delete && <button onClick={()=>{if(selected){setError('');setModal('delete');}}} disabled={!selected}
              style={{...s.btnDel,opacity:selected?1:.4}}>✕ حذف</button>}
          </div>
          <div style={{marginRight:'auto'}}>
            <input value={search} onChange={e=>setSearch(e.target.value)}
              placeholder="جستجو در عنوان" style={{...s.fI,width:'260px'}}/>
          </div>
        </div>

        <div style={s.infoBox}>
          گروه کاربری یک <b>برچسب روی خودِ داده</b> است، نه روی کاربر. هر سند، بستانکاری،
          حواله و مانند آن با کد گروه کاربریِ سازنده‌اش ذخیره می‌شود، و بعد هر کاربر فقط
          گروه‌هایی را می‌بیند که در «گروه‌های کاربری مجاز» او آمده باشد (مگر اینکه
          «دسترسی به کلیه گروه‌های کاربری» داشته باشد).
          <div style={{marginTop:'4px'}}>
            این با <b>گروه دسترسی</b> در صفحه کاربران فرق دارد: آن یکی تعیین می‌کند کاربر به
            کدام فرم و کلید دسترسی دارد؛ این یکی تعیین می‌کند کدام سطرهای داده را می‌بیند.
          </div>
        </div>

        <div style={s.tableWrap}>
          <table style={{width:'100%',borderCollapse:'collapse'}}>
            <thead style={{position:'sticky',top:0,zIndex:3}}>
              <tr>
                {['ردیف','کد','عنوان گروه کاربری','توضیح','کاربر این گروه','مجاز به دیدن']
                  .map(h=><th key={h} style={s.th}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {filtered.length===0 && (
                <tr><td colSpan={6} style={s.empty}>
                  {loading?'در حال بارگذاری...':'اطلاعاتی برای نمایش وجود ندارد'}</td></tr>)}
              {filtered.map((r,idx)=>{
                const sel = selected?.code===r.code;
                const bg = sel?'#64b5f6':idx%2===0?'#fff':'#fdf6e3';
                return (
                  <tr key={r.code} onClick={()=>setSelected(r)} style={{cursor:'pointer',background:bg}}
                    onMouseEnter={e=>{if(!sel)e.currentTarget.style.background='#bbdefb';}}
                    onMouseLeave={e=>{if(!sel)e.currentTarget.style.background=bg;}}>
                    <td style={s.td}>{toFa(idx+1)}</td>
                    <td style={s.td}>{toFa(r.code)}</td>
                    <td style={{...s.td,textAlign:'right'}}>{r.title}</td>
                    <td style={{...s.td,textAlign:'right',color:'#666'}}
                      title={r.remark}>{r.remark}</td>
                    <td style={{...s.td,fontWeight:'700',
                      color:r.user_count?'#1565c0':'#ccc'}}>{r.user_count?toFa(r.user_count):''}</td>
                    <td style={{...s.td,fontWeight:'700',
                      color:r.list_count?'#1b5e20':'#ccc'}}>{r.list_count?toFa(r.list_count):''}</td>
                  </tr>);
              })}
            </tbody>
          </table>
        </div>

        <div style={s.summary}>
          <span>تعداد: <b>{toFa(filtered.length)}</b></span>
          {selected && <span>انتخابی: <b>{selected.title}</b></span>}
        </div>
      </main>

      {(modal==='new'||modal==='edit') && (
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={{...s.modal,maxWidth:'480px'}} onClick={e=>e.stopPropagation()}>
            <div style={s.mHeader}>
              <div style={s.mTitle}>{modal==='new'?'➕ گروه کاربری جدید':'✎ ویرایش گروه کاربری'}</div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button></div>
            <div style={s.mBody}>
              {error&&<div style={s.errBox}>{error}</div>}
              <div style={{display:'flex',flexDirection:'column',gap:'4px',marginBottom:'12px'}}>
                <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>عنوان گروه کاربری</label>
                <input value={title} onChange={e=>setTitle(e.target.value)} style={s.fI}/>
              </div>
              <div style={{display:'flex',flexDirection:'column',gap:'4px'}}>
                <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>توضیح</label>
                <input value={remark} onChange={e=>setRemark(e.target.value)} style={s.fI}/>
              </div>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>لغو</button>
              <button onClick={save} style={s.btnSave}>ثبت</button>
            </div>
          </div>
        </div>
      )}

      {modal==='delete'&&selected&&(
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={{...s.modal,maxWidth:'460px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...s.mHeader,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>
              <div style={s.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button></div>
            <div style={s.mBody}>
              {error&&<div style={s.errBox}>{error}</div>}
              <p style={{fontSize:'14px',lineHeight:'2'}}>
                آیا از حذف گروه کاربری <b>{selected.title}</b> مطمئن هستید؟</p>
              {(selected.user_count>0||selected.list_count>0) &&
                <p style={{color:'#c62828',fontWeight:'700'}}>
                  ⚠️ این گروه کاربری در حال استفاده است
                  {selected.user_count>0?` — ${toFa(selected.user_count)} کاربر عضو آن`:''}
                  {selected.list_count>0?` — ${toFa(selected.list_count)} کاربر مجاز به دیدنش`:''}
                </p>}
              <p style={{fontSize:'12px',color:'#888'}}>
                اگر این گروه جایی استفاده شده باشد، حذف انجام نمی‌شود.
              </p>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>لغو</button>
              {selected.user_count===0 && selected.list_count===0 && <button onClick={del}
                style={{...s.btnSave,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>حذف</button>}
            </div>
          </div>
        </div>
      )}

      {toast&&<div style={s.toast}>{toast}</div>}
    </div>
  );
}

const s = {
  page:{height:'100vh',overflow:'hidden',background:'#f0f2f7',fontFamily:"'Vazirmatn',Tahoma,sans-serif",direction:'rtl',display:'flex',flexDirection:'column'},
  header:{background:'linear-gradient(135deg,#0a1628,#1a2f50)',padding:'10px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 16px rgba(0,0,0,0.3)',flexShrink:0},
  hLeft:{display:'flex',alignItems:'center',gap:'12px'},
  backBtn:{padding:'6px 14px',background:'rgba(255,255,255,0.12)',color:'#fff',border:'1px solid rgba(255,255,255,0.25)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  hLogo:{width:'40px',height:'40px',background:'rgba(200,168,75,0.12)',border:'1px solid rgba(200,168,75,0.3)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center'},
  hTitle:{fontSize:'15px',fontWeight:'700',color:'#fff'},
  hSub:{fontSize:'11px',color:'rgba(255,255,255,0.55)'},
  userName:{fontSize:'13px',color:'rgba(255,255,255,0.85)'},
  main:{padding:'8px 20px',flex:1,display:'flex',flexDirection:'column',overflow:'auto',minHeight:0},
  toolbar:{display:'flex',alignItems:'center',gap:'8px',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',marginBottom:'6px',flexWrap:'wrap',flexShrink:0},
  toolBtns:{display:'flex',gap:'7px'},
  fI:{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',textAlign:'right',boxSizing:'border-box',width:'100%'},
  btnNew:{padding:'7px 16px',background:'linear-gradient(135deg,#1b5e20,#2e7d32)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  btnEdit:{padding:'7px 16px',background:'linear-gradient(135deg,#1a237e,#283593)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnDel:{padding:'7px 16px',background:'linear-gradient(135deg,#b71c1c,#c62828)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  infoBox:{background:'#e3f2fd',border:'1px solid #90caf9',borderRadius:'10px',padding:'10px 14px',color:'#0d47a1',fontSize:'12px',lineHeight:'2',marginBottom:'6px',flexShrink:0},
  tableWrap:{overflowX:'auto',overflowY:'auto',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.1)',background:'#fff',flex:1,minHeight:'240px'},
  th:{padding:'9px',background:'#0d2137',color:'#C8A84B',fontSize:'12px',fontWeight:'700',whiteSpace:'nowrap',position:'sticky',top:0},
  td:{padding:'7px 9px',borderBottom:'1px solid #f0f0f0',textAlign:'center',fontSize:'12px'},
  empty:{textAlign:'center',padding:'40px',color:'#999',fontSize:'13px'},
  summary:{display:'flex',gap:'18px',flexWrap:'wrap',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',margin:'6px 0',fontSize:'12px',color:'#444',flexShrink:0},
  overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.55)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'},
  modal:{background:'#fff',borderRadius:'16px',width:'100%',maxHeight:'92vh',display:'flex',flexDirection:'column',boxShadow:'0 20px 60px rgba(0,0,0,0.4)'},
  mHeader:{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'14px 20px',background:'linear-gradient(135deg,#0a1628,#1a2f50)',borderRadius:'16px 16px 0 0'},
  mTitle:{fontSize:'14px',fontWeight:'700',color:'#fff'},
  closeBtn:{background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',color:'#fff',width:'30px',height:'30px',borderRadius:'50%',cursor:'pointer',fontSize:'13px',display:'flex',alignItems:'center',justifyContent:'center'},
  mBody:{overflowY:'auto',flex:1,padding:'18px'},
  mFooter:{display:'flex',justifyContent:'flex-end',gap:'10px',padding:'12px 18px',borderTop:'1px solid #f0f2f7',background:'#f8f9fa',borderRadius:'0 0 16px 16px'},
  errBox:{background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'8px',padding:'10px 14px',color:'#c62828',marginBottom:'10px',fontSize:'13px'},
  btnCancel:{padding:'8px 18px',background:'#e0e0e0',color:'#333',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  btnSave:{padding:'8px 22px',background:'linear-gradient(135deg,#1b5e20,#2e7d32)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  toast:{position:'fixed',bottom:'24px',right:'24px',background:'#1b5e20',color:'#fff',padding:'12px 24px',borderRadius:'10px',fontSize:'14px',fontWeight:'600',zIndex:2000,boxShadow:'0 4px 16px rgba(0,0,0,0.25)'},
};
